import { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import ChartTooltip from '../ChartTooltip/ChartTooltip'
import styles from './ChartHoverSelector.module.scss'

const ChartHoverSelector = ({ index, data, setIndex }) => {
  const inputRef = useRef()
  const [count, setCount] = useState(index)

  useEffect(() => {
    if (index !== count) {
      const newCount = index - count > 0 ? count + 1 : count - 1
      setCount(newCount)
    }
  }, [index, count])

  const newIndexOnChange = e => Math.round(parseInt(e.target.value))
  const newIndexOnMouseMove = e =>
    Math.round(
      (e.nativeEvent.offsetX / e.target.clientWidth) * (data.length - 1)
    )

  return (
    <>
      {!!data[count] && (
        <ChartTooltip
          leftAlignmentPercentage={`${(index / (data.length - 1)) * 100}%`}
          flipTooltipPosition={index > data.length / 2}
          value={Math.floor(data[count].value)}
          month={data[count].month}
        />
      )}
      <input
        className={styles.chartInput}
        ref={inputRef}
        tabIndex='-1'
        aria-label='range'
        type='range'
        value={index}
        onMouseMove={e => setIndex(newIndexOnMouseMove(e))}
        onChange={e => setIndex(newIndexOnChange(e))}
        step='1'
        min='0'
        max={Math.max(0, data.length - 1)}
      />
    </>
  )
}

ChartHoverSelector.propTypes = {
  index: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      month: PropTypes.string,
    })
  ),
  setIndex: PropTypes.func,
}

export default ChartHoverSelector
